import { Component } from '@angular/core';

@Component({
  selector: 'challenges-skeleton',
  templateUrl: './challenges-skeleton.component.html',
  styleUrls: ['./challenges-skeleton.component.scss'],
})
export class ChallengesSkeletonComponent {}
